import React from "react";
import { Card, Row, Col, Space, Typography } from "antd";
import { DragOutlined } from "@ant-design/icons";
import InnerCard from "./InnerCard";
import RenderInput from "./RenderInput";
import RenderAddButton from "./RenderAddButton";
import RenderDeleteButton from "./RenderDeleteButton";
import RenderSelect from "./RenderSelect";
import AddSubSection from "./AddSubsection";

const { Text } = Typography;

const SingleCard = ({
  data,
  index,
  dragToggle,
  onDragStart,
  onDrop,
  onDragOver,
  onDragEnd,
  onDragEnter,
  onInputChange,
  addButtonStateChange,
  dragInnerItem,
  dropInnerItem,
  allowDropInnerItem,
  leaveDropInner,
  inputsInnerWrapperRef,
  deleteSection,
  renderSelectedItem,
  addSubSection,
  addOption,
}) => {
  return (
    <>
      <Card
        style={{ marginBottom: 16 }}
        id={`box-${index}`}
        draggable={dragToggle}
        onDragStart={(event) => onDragStart(event)}
        onDrop={(event) => onDrop(event)}
        onDragOver={(event) => onDragOver(event)}
        onDragEnd={(event) => onDragEnd(event)}
        //onDragLeave={(event) => this.leaveDrop(event)}
        onDragEnter={(event) => onDragEnter(event)}
        title={
          <>
            <Row gutter={[16, 16]}>
              <Col span={10}>
                <RenderInput
                  index={index}
                  onInputChange={onInputChange}
                  keyTitle={"title"}
                  placeholder="Section Title"
                  value={data.title}
                  id={data.id}
                />
              </Col>
              <Col span={10}></Col>
              <Col span={4}>
                {!dragToggle && (
                  <RenderDeleteButton
                    title="Delete Section"
                    id={data.id}
                    deleteSection={deleteSection}
                  />
                )}
              </Col>
            </Row>
          </>
        }
        extra={dragToggle && <DragOutlined />}
      >
        <AddSubSection
          dragToggle={dragToggle}
          addButtonVisible={data.addButtonVisible}
          addButtonStateChange={addButtonStateChange}
          itemId={data.id}
          index={index}
          addSubSection={addSubSection}
          addOption={addOption}
        />
        <div
          ref={inputsInnerWrapperRef}
          key={`box-inner-${data.id}`}
          id={`box-inner-${data.id}`}
        >
          {data.hasOwnProperty("subSectionsList") &&
            data.subSectionsList.length > 0 &&
            data.subSectionsList.map((element, i) =>
              element.hasOwnProperty("is_sub_heading") ? (
                <div
                  key={`box-inner-section-${data.id}-${element.id}`}
                  id={`box-inner-section-${data.id}-${element.id}`}
                  className={dragToggle ? "without-padding" : ""}
                  draggable={dragToggle}
                  onDragStart={(event) => dragInnerItem(event)}
                  onDrop={(event) => dropInnerItem(event)}
                  onDragOver={(event) => allowDropInnerItem(event)}
                  onDragEnd={(event) => leaveDropInner(event)}
                >
                  <InnerCard
                    onInputChange={onInputChange}
                    index={index}
                    itemId={data.id}
                    nestedIndex={i}
                    data={data}
                    deleteSection={deleteSection}
                    dragToggle={dragToggle}
                    keyTitle={"sub_heading_title"}
                    placeholder="Heading Title"
                    // key={`input-section-sub_heading_title-${data.id}-${i}`}
                    isHeading={true}
                    renderSelectedItem={renderSelectedItem}
                    addOption={addOption}
                    addSubSection={addSubSection}
                    newId={i}
                  />
                  <AddSubSection
                    dragToggle={dragToggle}
                    addButtonVisible={data.subSectionsList[i].addButtonVisible}
                    addButtonStateChange={addButtonStateChange}
                    itemId={data.id}
                    index={index}
                    nestedIndex={i}
                    addOption={addOption}
                    addSubSection={addSubSection}
                  />
                </div>
              ) : (
                <div
                  key={`box-inner-section-${data.id}-${element.id}`}
                  id={`box-inner-section-${data.id}-${element.id}`}
                  className={dragToggle ? "without-padding" : ""}
                  draggable={dragToggle}
                  onDragStart={(event) => dragInnerItem(event)}
                  onDrop={(event) => dropInnerItem(event)}
                  onDragOver={(event) => allowDropInnerItem(event)}
                  onDragEnd={(event) => leaveDropInner(event)}
                  //onDragLeave={(event) => this.leaveDropInner(event)}
                  //onDragEnter={(event) => this.onDragEnter(event)}
                >
                  <InnerCard
                    onInputChange={onInputChange}
                    index={index}
                    itemId={data.id}
                    nestedIndex={i}
                    data={data}
                    deleteSection={deleteSection}
                    dragToggle={dragToggle}
                    keyTitle={"title"}
                    placeholder="Label"
                    // key={`input-section-title-${data.id}-${i}`}
                    isHeading={false}
                    element={element}
                    renderSelectedItem={renderSelectedItem}
                    addOption={addOption}
                    addSubSection={addSubSection}
                    newId={i}
                  />
                  <AddSubSection
                    dragToggle={dragToggle}
                    addButtonVisible={data.subSectionsList[i].addButtonVisible}
                    addButtonStateChange={addButtonStateChange}
                    itemId={data.id}
                    nestedIndex={i}
                    index={index}
                    addOption={addOption}
                    addSubSection={addSubSection}
                  />
                </div>
              )
            )}
        </div>
      </Card>
    </>
  );
};

export default SingleCard;
